import { render, staticRenderFns } from "./deliveredRequests.vue?vue&type=template&id=0796737d&scoped=true&"
import script from "./deliveredRequests.vue?vue&type=script&lang=js&"
export * from "./deliveredRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0796737d",
  null
  
)

export default component.exports